import { useEffect } from 'react'
import { customizeError } from '@chilecompra/react-kit/errors'

/**
 * useRequestInterceptor is a custom React hook that intercepts XMLHttpRequests for a specific URL,
 * extracts the payload sent in the request, and processes the response from the server to update the state.
 **/
const useRequestInterceptor = (urlToIntercept, setFiles) => {
  useEffect(() => {
    const originalXhrOpen = XMLHttpRequest.prototype.open
    const originalXhrSend = XMLHttpRequest.prototype.send

    let payloadData = null

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      if (url.includes(urlToIntercept)) {
        this.addEventListener('load', function () {
          try {
            const responseText = this.responseText
            const parsedResponse = JSON.parse(responseText)

            if (parsedResponse.iddoc && parsedResponse.URL && payloadData?.filename) {
              const filteredResponse = {
                iddoc: parsedResponse.iddoc,
                filename: payloadData.filename
              }

              setFiles(prevFiles => {
                const updatedFiles = prevFiles.filter(file => file.iddoc !== filteredResponse.iddoc)
                return [...updatedFiles, filteredResponse]
              })
            }
          } catch (error) {
            throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
          }
        })
      }

      return originalXhrOpen.apply(this, [method, url, ...rest])
    }

    XMLHttpRequest.prototype.send = function (body) {
      if (body) {
        if (typeof body === 'string' && body.startsWith('{')) {
          try {
            const parsedPayload = JSON.parse(body)
            payloadData = parsedPayload
          } catch (error) {
            throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
          }
        }
      }

      return originalXhrSend.apply(this, arguments)
    }

    return () => {
      XMLHttpRequest.prototype.open = originalXhrOpen
      XMLHttpRequest.prototype.send = originalXhrSend
    }
  }, [urlToIntercept, setFiles])
}

export default useRequestInterceptor
